export default __webpack_public_path__ + "static/media/picto-burger.c28e03de.svg";